export default "__VITE_ASSET__181e064f__"